const BUTTON = 'button';
const CHECKBOX = 'checkbox';
const DROPDOWN = 'dropdown';
const EMAIL = 'email';
const NUMBER = 'number';
const PASSWORD = 'password';
const RADIO_BUTTON = 'radioButton';
const RESET = 'reset';
const SUBMIT = 'submit';
const TELEPHONE = 'tel';
const TEXT = 'text';


export const INPUT_TYPES = {
    BUTTON,
    CHECKBOX,
    DROPDOWN,
    EMAIL,
    NUMBER,
    PASSWORD,
    RADIO_BUTTON,
    RESET,
    SUBMIT,
    TELEPHONE,
    TEXT
};